import LiquidCurrencyDropdown from './liquid_currency_dropdown'
import VueLoader from '../../default/vue-loader'
import { store } from'../../default/store'

export default {
  loadCurrencyDropdown(){
    VueLoader.loadVueComponent(LiquidCurrencyDropdown, document.getElementById('LiquidCurrencyDropdown'),store)
  }
}